import {twMerge} from '../../../common/twMerge';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {ArrowButtonSize} from '../../molecules/ArrowButton/ArrowButton.enum';
import {Carousel} from '../../molecules/Carousel/Carousel';
import {ScrollableHorizontalList} from '../../molecules/ScrollableHorizontalList/ScrollableHorizontalList';
import {WelcomeRecommendContentItem} from '../WelcomeRecommendContentItem/WelcomeRecommendContentItem';
import {WelcomeRecommendContentListProps} from './WelcomeRecommendContentListProps.interface';

export function WelcomeRecommendContentList({
  isMobile,
  contentList,
  onChangeIndex,
  ...props
}: WelcomeRecommendContentListProps) {
  const recommendContentItems = contentList.map((content, index) => {
    return (
      <WelcomeRecommendContentItem
        key={content.title + index}
        scheme={content.scheme}
        src={content.thumbnail}
        title={content.title}
        category={content.category}
        subCategory={content.subCategory}
        viewCount={content.viewCount}
        freeSlideCount={content.freeSlideCount}
        authors={content.authors}
        themeKeywordList={content.themeKeywordList}
        description={content.description}
        className={twMerge(isMobile ? 'foldable:w-[328px]' : 'w-288pxr')}
        {...putTiaraObjectProps({
          eventMeta: {
            id: String(content.seriesId),
            type: 'seriesId',
            name: content.title,
            category: content.category,
            subcategory: content.subCategory,
            provider: '서비스',
            series: content.title,
            series_id: String(content.seriesId),
          },
          click: {
            ordnum: String(index + 1),
            copy: `${content.freeSlideCount}화 무료 보러가기`,
          },
          customProps: {landing_path: 'contents'},
        })}
      />
    );
  });
  return (
    <div {...props}>
      <Carousel
        isInfinite={false}
        isCenterMode={true}
        centerPadding={'17.5px'}
        isLeftSideMode={true}
        gapPx={6}
        className={twMerge(
          'w-full overflow-hidden drop-shadow-[0px_20px_36px_rgba(0,0,0,0.15)] use-gpu',
          // 모바일버전이고 534px 미만일 경우 carousel을 보여줌
          isMobile ? 'foldable:hidden' : 'hidden'
        )}
        onChangeIndex={onChangeIndex}
      >
        {recommendContentItems}
      </Carousel>

      <ScrollableHorizontalList
        isMobile={isMobile}
        isOuterArrow={true}
        arrowButtonSize={ArrowButtonSize.Large}
        gapPx={isMobile ? 12 : 22}
        className={twMerge(
          'drop-shadow-[0px_14px_48px_rgba(0,0,0,0.15)]',
          //모바일 폴더블 버전 이상과 PC버전에서는 ScrollableHorizontalList을 보여줌
          isMobile ? 'under-foldable:hidden' : undefined
        )}
        innerLeftPx={isMobile ? 15 : 0}
        innerRightPx={isMobile ? 15 : 0}
      >
        {recommendContentItems}
      </ScrollableHorizontalList>
    </div>
  );
}
